/*
  Custom quick add
  Example usage: Call the addToCart method directly with the product URL used for quick add to cart buttons
  ---
  const exampleProductUrl = 'https://client-site.myshopify.com/products/product-handle';

*/

class UAKlaviyo {
  renderQuickBuyKlaviyoBIS(quickbuyDrawer) {
    const klaviyoBISButton = quickbuyDrawer.querySelector('.klaviyo-bis-trigger');
    if (!klaviyoBISButton) return;

    klaviyoBISButton.style.display = 'none';
  }
}

class KlaviyoNotifyButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick);
  }

  onClick() {
    const has_anchor = this.querySelector('a');
    const template = this.querySelector('.klaviyo-bis-template');
    const backInStockEl = document.querySelector('.klaviyo-button-container');
    if (!has_anchor && template) {
      const templateHTML = template.innerHTML;
      backInStockEl.innerHTML = templateHTML;
      backInStockEl.querySelector('a')?.click();
    }
  }
}

customElements.define('klaviyo-notify-button', KlaviyoNotifyButton);

const uaKlaviyo = new UAKlaviyo();

class KlaviyoButton extends HTMLElement {
  constructor() {
    super();
    this.formId = this.dataset.formId;
  }

  connectedCallback() {
    if (!this.formId) {
      console.error('You must provide a form-id attribute to use this component');
      return;
    }

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', this.formId, () => {
    }]);
  }
}

customElements.define('klaviyo-button', KlaviyoButton);